// This filters the unfiltered change notification message.
// TODO: Need to edit this in Notification DynamoDB table
export const NOTIFICATION_CHANGE_PLAN_APPROVED =
    "The treatment plan is approved";
